import { forwardRef, memo } from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export const IconChannelWrike = memo(
  forwardRef((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 24 24"
      >
        <path
          d="M7.69805 10.6351C8.46136 10.6351 8.82118 10.7755 9.3738 11.3288L12.3394 14.2966C12.4273 14.3844 12.4449 14.4196 12.4623 14.4722C12.4712 14.4898 12.4712 14.5161 12.4712 14.5337C12.4712 14.5513 12.4712 14.5776 12.4623 14.5952C12.4449 14.6478 12.4273 14.683 12.3394 14.7708L10.3128 16.8077C10.225 16.8955 10.19 16.9131 10.1371 16.9307C10.1197 16.9394 10.0934 16.9394 10.0758 16.9394C10.0582 16.9394 10.0319 16.9394 10.0143 16.9307C9.96166 16.9131 9.92668 16.8955 9.83883 16.8077L4.09168 11.0565C3.92518 10.8896 3.98647 10.6351 4.26738 10.6351H7.69805ZM16.0684 7.00867C15.3051 7.00867 14.9452 7.14904 14.3926 7.70237L11.427 10.6701C11.3391 10.7579 11.3215 10.7931 11.3042 10.8457C11.2952 10.8633 11.2952 10.8896 11.2952 10.9072C11.2952 10.9248 11.2952 10.9511 11.3042 10.9687C11.3215 11.0213 11.3391 11.0565 11.427 11.1443L13.4536 13.1726C13.5415 13.2604 13.5765 13.278 13.6293 13.2956C13.6467 13.3043 13.673 13.3043 13.6906 13.3043C13.7082 13.3043 13.7345 13.3043 13.7522 13.2956C13.8048 13.278 13.8397 13.2604 13.9276 13.1726L19.6745 7.42137C19.8412 7.25445 19.78 7 19.499 7H16.0684V7.00867Z"
          fill="#08CF65"
        />
      </SvgIcon>
    );
  })
);
